export default "__VITE_ASSET__BoVsS0Iv__"